import { render, staticRenderFns } from "./DxpPageFooter.vue?vue&type=template&id=c06ff570&scoped=true"
import script from "./DxpPageFooter.vue?vue&type=script&lang=js"
export * from "./DxpPageFooter.vue?vue&type=script&lang=js"
import style0 from "./DxpPageFooter.vue?vue&type=style&index=0&id=c06ff570&prod&lang=scss&scoped=true"
import style1 from "./DxpPageFooter.vue?vue&type=style&index=1&id=c06ff570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ff570",
  null
  
)

export default component.exports